module.exports = __webpack_public_path__ + "assets/images/project/head/Kim_Na-young.jpg?v=c18ebfde";